import { useStore } from '@betgames/bg-state-manager';
import { useAfterUpdate } from '@betgames/bg-tools';
import { analytics } from 'repositories/AnalyticsRepository';
import { gAnalytics } from 'repositories/GAnalyticsRepository';
import { app, appSelectors } from 'store/App';
import { sessionStore } from 'store/Session';
import { analyticsService } from 'services/AnalyticsService';

export const useAnalytics = (urlPath: string): (() => Promise<void>) => {
    const partnerCode = useStore(app.store, appSelectors.getPartnerCode);

    const init = async (): Promise<void> => {
        try {
            const { userId } = sessionStore;

            analytics.init({
                partnerCode,
                userId,
                path: urlPath,
            });

            gAnalytics.init({
                partnerCode,
                userId,
            });

            analyticsService.init(analytics, gAnalytics);
        } catch {}
    };

    useAfterUpdate(() => {
        analytics.trackLocationChange(urlPath);
    }, [urlPath]);

    return init;
};
